import * as React from "react";
import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import VideoPlayerControls from "./VideoPlayerControls";
import VideoPlaceholder from "../images/MtA_intro_still.jpg";
import VideoLoadSpinner from "../images/MtA_loading_200px.gif";
import SmallVideoLoadSpinner from "../images/MtA_loading_100px.gif";


function VideoPlayer(props) {
   
    let [renderControls, setRenderControls] = useState(false);
    let videoRef = useRef();
    let imageRef = useRef();
    let [playerPaused, setPlayerPaused] = useState(false);
    let [playerPropDone, setPlayerPropDone] = useState(0);
    let [videoLoaded, setVideoLoaded] = useState(false);

    let navigate = useNavigate();

    useEffect(() => {
        if (videoLoaded) {
            videoRef.current.style.display = "inline";
            imageRef.current.style.display = "none";
        }else{
            videoRef.current.style.display = "none";
            imageRef.current.style.display = "inline";
        }
    }, [videoLoaded]);

    // Set either the custom controls or the attributes of the video player
    useEffect(() => {
        if (props.controls) {
            setRenderControls(true);
        }else{
            videoRef.current.setAttribute("controls", "controls");
            videoRef.current.setAttribute("controlsList", "nodownload");
            videoRef.current.removeAttribute("autoPlay");
        }
    }, [props]);

    useEffect(() => {
        const videoProgressTimer = setInterval(() => {
                setPlayerPropDone(videoRef.current.currentTime/videoRef.current.duration);
        }, 500);
        return () => clearInterval(videoProgressTimer);
    });

    // Exiting behavior
    useEffect(() => {
        let timeoutID = null;
        if (playerPaused && playerPropDone > 0.95 && props.exitDelay) {
            timeoutID = setTimeout(() => {
                props.setExiting(true);
            }, props.exitDelay);
        } else {
            clearTimeout(timeoutID);
        }
    }, [playerPaused, navigate, props, playerPropDone]);

    // Send the video progress to the parent element for analytics
    useEffect(() => {
        props.setProfileVideoProgress(playerPropDone)
    }, [props, playerPropDone])


    return (
        <Box sx={props.vidStyle}>
            <video
                autoPlay
                ref={videoRef}
                onPause={() => {
                    setPlayerPaused(true);
                }}
                onPlay={() => {
                    setPlayerPaused(false);
                }}
                onLoadedData={() => {
                    setVideoLoaded(true);
                }}
                style={props.vidStyle}
            >
                <source src={props.vidSrc} type="video/mp4" />
                Sorry, your browser doesn't support embedded videos.
            </video>
            <div
                ref={imageRef}
                style={{
                    position: 'relative',
                    float: 'left',
                    marginBottom: renderControls ? '75px' : "",
                    marginLeft: renderControls ? '0px' : ""
                }}>
                <img 
                    src={VideoPlaceholder}
                    alt="We the Culture"
                    style ={props.vidStyle}
                />
                <img 
                    src={props.mobile ? SmallVideoLoadSpinner : VideoLoadSpinner}
                    alt="Load Spinner"
                    style={{
                        position:'absolute',
                        top: props.mobile ? '30%' : '50%',
                        right:'50%',
                        transform: 'translate(50%,0%)',
                    }}
                />
            </div>
            {renderControls ? <VideoPlayerControls videoRef={videoRef} /> : ""}
        </Box>
    );
}

export default VideoPlayer;
